import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { uploadVideo } from 'redux/modules/composebox';
import { addVideo, orgInitialState, removeVideo } from 'redux/modules/groupPostCompose';
import io from 'socket.io-client';
import { Spinner } from 'components';
import * as styles from './Group.scss';
import request from 'superagent';

var Dropzone = require('react-dropzone');

var GVideoPostSection = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    groupPost: state.groupPostCompose,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    uploadingVideo: state.composebox.uploadingVideo
  };
}, {
  addVideo: addVideo,
  removeVideo: removeVideo,
  uploadVideo: uploadVideo
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(GVideoPostSection, _Component);

  var _super = _createSuper(GVideoPostSection);

  function GVideoPostSection(props) {
    var _this;

    _classCallCheck(this, GVideoPostSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.websocket.on('video_did_process', function (data) {
        if (_this.props.groupPost.videoUrl === data.old_url) {
          console.log('video_did_process');
          console.dir(data);

          _this.setState({
            processingVideo: false
          });

          _this.props.addVideo(data.new_url, _this.props.organizationId);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getVideoThumbnail", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var jpegImage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              jpegImage = "".concat(_this.props.groupPost.videoUrl.substr(0, _this.props.groupPost.videoUrl.lastIndexOf('.')), ".jpg");
              return _context.abrupt("return", jpegImage);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "socketConfig", function (path) {
      var location = '';

      if (_this.props.config.appEnv === 'production') {
        location = 'https://api-prod.likeablelocal.com';
      } else if (_this.props.config.appEnv === 'demo') {
        location = 'https://api-prod.likeabledemos.com';
      }

      return {
        location: location,
        config: {
          path: path,
          autoConnect: true
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "websocket", io(_this.socketConfig('/ws').location, _objectSpread({}, _this.socketConfig('/ws').config)));

    _defineProperty(_assertThisInitialized(_this), "onDropFunc", function (files) {
      var _this$props = _this.props,
          groupPost = _this$props.groupPost,
          organizationId = _this$props.organizationId;
      console.log('in onDropFunc in video post section');
      console.dir(files);

      if (files && files.length > 0) {
        var uploadFiles = files;

        if (files.length > _this.state.maxVideoCount) {
          uploadFiles = files.slice(0, _this.state.maxVideoCount);
        }

        _this.props.uploadVideo(uploadFiles, 'video').then( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(result) {
            var videoPreviewImageValid;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    videoPreviewImageValid = false;
                    _context2.prev = 1;
                    _context2.next = 4;
                    return request.head(_this.getVideoThumbnail);

                  case 4:
                    videoPreviewImageValid = true;
                    _context2.next = 9;
                    break;

                  case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2["catch"](1);

                  case 9:
                    _this.props.addVideo(result.data[0].fullyQualifiedUrl, organizationId);

                    if (result.data[0].bucketName === 'blarplesnurf' || result.data[0].bucketName === 'blarplesnurf-staging') {
                      _this.setState({
                        processingVideo: true,
                        videoPreviewImageValid: videoPreviewImageValid
                      });
                    } else {
                      _this.setState({
                        videoPreviewImageValid: videoPreviewImageValid
                      });
                    }

                  case 11:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[1, 7]]);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }())["catch"](function (err) {
          console.error(err);
        });
      }
    });

    _this.state = {
      maxVideoCount: 1,
      processingVideo: false,
      videoPreviewImageValid: false
    };
    return _this;
  }
  /** *********************************************************
   LIFECYCLE METHODS
   ***********************************************************/


  _createClass(GVideoPostSection, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.websocket.off('video_did_process');
    }
    /** *********************************************************
     CUSTOM METHODS
     ***********************************************************/

  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      var groupPost = this.props.groupPost;
      var videoThumbnail = groupPost.videoUrl ? this.getVideoThumbnail() : '';
      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h4", {
        style: {
          color: '#8b8b8b'
        }
      }, "Upload Video"), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          minHeight: 125,
          position: 'relative'
        }
      }, groupPost.videoUrl && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.imageCloseBtn,
        onClick: function onClick() {
          return _this2.props.removeVideo(_this2.props.organizationId);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-close-empty ".concat(styles.imageCloseBtnIcon)
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.uploadedImage,
        style: videoThumbnail && this.state.videoPreviewImageValid ? {
          backgroundImage: "url(".concat(videoThumbnail, ")")
        } : {}
      }, (!videoThumbnail || !this.state.videoPreviewImageValid) && /*#__PURE__*/React.createElement("video", {
        className: styles.videoPreviewThumbnail,
        onContextMenu: function onContextMenu(e) {
          return e.preventDefault();
        },
        muted: true,
        src: groupPost.videoUrl
      }))), !groupPost.videoUrl && !this.props.uploadingVideo && !this.state.processingVideo && /*#__PURE__*/React.createElement(Dropzone, {
        multiple: true,
        style: {
          width: 120,
          height: 120,
          borderColor: '#8b8b8b',
          borderRadius: 4,
          border: '1px dashed #8b8b8b'
        },
        onDrop: this.onDropFunc,
        accept: "video/mp4,video/x-m4v,video/*"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center',
          position: 'relative',
          top: '25%',
          color: '#8b8b8b',
          fontSize: 13,
          padding: 8
        }
      }, "Drag and drop a video here or click to upload.")), (this.props.uploadingVideo || this.state.processingVideo) && /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })))));
    }
  }]);

  return GVideoPostSection;
}(Component)) || _class);
export { GVideoPostSection as default };